import DeleteSocialMediaModal from './DeleteSocialMediaModal'

export default DeleteSocialMediaModal
